import { Link } from 'react-router'
import DeveloperBoard from '@mui/icons-material/DeveloperBoard'
import { Box, CardActionArea, Paper, Stack, Typography } from '@mui/material'
import useLocationHelpers from '@/hooks/useLocationHelpers'
import { ProjectLinkedModel } from '@/types/project-linked-models'

type ModelCardProps = {
  projectLinkedModel: ProjectLinkedModel
  modelName: string
  modelType: string
}

export default function ModelCard({
  projectLinkedModel,
  modelName,
  modelType,
}: ModelCardProps) {
  const { appendCurrentParamsToUrl } = useLocationHelpers()

  return (
    <Paper
      variant="outlined"
      sx={{ height: '100%', borderRadius: 2, overflow: 'hidden' }}
    >
      <CardActionArea
        component={Link}
        to={`./${appendCurrentParamsToUrl(projectLinkedModel.id)}`}
        sx={{ height: '100%' }}
      >
        <Stack direction="row" sx={{ height: '100%' }}>
          <Stack
            spacing={0.25}
            sx={{ px: 2.5, py: 2, flexGrow: 1, minWidth: 0 }}
          >
            <Typography
              color="text.secondary"
              sx={{ fontSize: '0.8125rem', lineHeight: 1.5 }}
            >
              {modelType}
            </Typography>
            <Typography
              component="h2"
              sx={{ fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 }}
            >
              {modelName}
            </Typography>
          </Stack>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 72,
              flexShrink: 0,
              borderLeft: 1,
              borderColor: 'divider',
              bgcolor: 'action.hover',
              color: 'text.secondary',
            }}
          >
            <DeveloperBoard sx={{ fontSize: 32 }} />
          </Box>
        </Stack>
      </CardActionArea>
    </Paper>
  )
}
